import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Classes from "./ProjectDetail.module.css";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function ProjectDetail() {
    const navigateTo = useNavigate();
    const fileInputRef = useRef(null);

    // States
    const [projectTitle, setProjectTitle] = useState("");
    const [website, setWebsite] = useState("");
    const [projectDetails, setProjectDetails] = useState("");
    const [uiuxType, setUiuxType] = useState("");
    const [additionalInfo, setAdditionalInfo] = useState("");
    const [files, setFiles] = useState([]);
    const [dragging, setDragging] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleBackClick = () => navigateTo("/services");

    // File Drag & Drop Handlers
    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    // File Input Change
    const handleFileChange = (e) => {
        setFiles((prevFiles) => [...prevFiles, ...Array.from(e.target.files)]);
    };

    // Trigger file input click when clicking "Browse"
    const handleBrowseClick = () => {
        fileInputRef.current.click();
    };

    // Form Submit Handler
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log({
            projectTitle,
            website,
            projectDetails,
            uiuxType,
            files,
            additionalInfo,
            isChecked
        });
    };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Go back</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <h3>Project Details</h3>

                <form onSubmit={handleSubmit}>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Project Title</label>
                        <input type="text" className={Classes.inputField} value={projectTitle} onChange={(e) => setProjectTitle(e.target.value)} placeholder="Enter project title" />
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Your Website</label>
                        <input type="text" className={Classes.inputField} value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="Enter website URL" />
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Describe Your Project Details</label>
                        <textarea
                            rows="5"
                            className={Classes.inputField}
                            value={projectDetails} onChange={(e) => setProjectDetails(e.target.value)} placeholder="Enter project details"
                            style={{ resize: "none" }}
                        ></textarea>
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>What type of UI/UX are you looking for?</label>
                        <input type="text" className={Classes.inputField} value={uiuxType} onChange={(e) => setUiuxType(e.target.value)} placeholder="Enter UI/UX type" />
                    </div>

                    <div className='flexAlign10' >
                        <label className={Classes.label}>Upload your brand assets</label>
                        <div className="optionalText"> <h5> Optional </h5> </div>
                    </div>
                    {/* File Upload Section */}
                    <div
                        className={`${Classes.fileUpload} ${dragging ? Classes.dragActive : ""}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleBrowseClick} // Trigger file input on click
                    >
                        <input
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            className={Classes.fileInput}
                            ref={fileInputRef} // Connect input ref
                        />
                        <h5>
                            <span className={Classes.browseText}>Browse</span> or drag and drop files here
                        </h5>
                    </div>

                    {/* File List Preview */}
                    {files.length > 0 && (
                        <ul className={Classes.fileList}>
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    )}

                    <div className={Classes.flexCol1}>
                        <div className='flexAlign10' >
                            <label className={Classes.label}>Anything else we should know?</label>
                            <div className="optionalText"> <h5> Optional </h5> </div>
                        </div>
                        <textarea
                            rows="5"
                            className={Classes.inputField}
                            value={additionalInfo} onChange={(e) => setAdditionalInfo(e.target.value)} placeholder="Additional information"
                            style={{ resize: "none" }}
                        ></textarea>
                    </div>

                    <div className="flexAlign10" >
                        <input type="checkbox" />
                        <label className={Classes.label}>The information above is correct and complete.</label>
                    </div>

                    <div className={Classes.flexEnd}>
                        <button type="submit" className={Classes.submitBtn}>
                            <h5>Continue to Payment</h5>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
